import router from './router'
import NotificationMessages from './localization'

export default {
  router,
  localization: NotificationMessages,
}
